import {Component, Input} from '@angular/core';
import {Proposal} from '../../../model/proposal/proposal';

@Component({
    selector: 'app-insurance-contract-detail-individual-clauses-conditions',
    templateUrl: './insurance-contract-detail-individual-clauses-conditions.component.html',
    standalone: false
})
export class InsuranceContractDetailIndividualClausesConditionsComponent {
  @Input() proposal: Proposal;

}
